module.exports = require("./fr-CI");